import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ConsultationPage from '../pages/consultation/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/consultation',
    element: <ConsultationPage />
  },
  {
    path: '/services',
    element: <HomePage />
  },
  {
    path: '/programs',
    element: <HomePage />
  },
  {
    path: '/process',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <HomePage />
  },
  {
    path: '/contact',
    element: <ConsultationPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;